import { createApp } from "vue";
import * as VueRouter from 'vue-router';
import App from "./App.vue";
import Home from "./components/Home.vue";
import Dementia from "./components/Dementia.vue";
import videoL from "./components/VideoL.vue";
import Login from "./components/Login.vue";
import Logout from "./components/Logout.vue";
import CheckPoint from "./pages/CheckPoint.vue";
import CheckPointClock from "./pages/CheckPointClock.vue";
import CheckPointBathroom from "./pages/CheckPointBathroom.vue";
import CheckPointTrash from "./pages/CheckPointTrash.vue";
import CheckPointScreen from "./pages/CheckPointScreen.vue";
import CheckPointCalculate from "./pages/CheckPointCalculate.vue";
import CheckPointFlip from "./pages/CheckPointFlip.vue";
import { createStore } from 'vuex';

// import soundBackground from './js/sound-background';
// soundBackground();

const store = createStore({
    state () {  
        return {
            level: 'easy',
            isLogin: false,
            user_id: '',
            checkpoints: [],
            user: {}
        }
    },
    mutations: {
        UPDATE_STATE_LEVEL(state, payload) {
            state.level = payload;
        },
        UPDATE_IS_LOGIN(state, payload) {
            state.isLogin = payload;
        },
        UPDATE_CHECKPOINT(state, payload) {
            state.checkpoints = payload;
        },
        UPDATE_USER_ID(state, payload){
            state.user_id = payload;
        },
        UPDATE_USER(state, payload){
            state.user = payload;
        },
        LOGOUT(state, payload) {
            state.user_id = '';
            state.isLogin = payload;
        }
    },
    actions: {
        setLevel(context,level) {            
            context.commit('UPDATE_STATE_LEVEL', level);
        },
        setIsLogin(context, status) {            
            context.commit('UPDATE_IS_LOGIN', status);
        },
        setCheckPoint(context, checkpoints) {            
            context.commit('UPDATE_CHECKPOINT', checkpoints);
        },
        setUserId(context, user_id) {            
            context.commit('UPDATE_USER_ID', user_id);
        },
        setUser(context, user) {            
            context.commit('UPDATE_USER', user);
        },
        Logout(context, status) {            
            context.commit('LOGOUT', status);
        }
    },
});

const routes = [
    { path: '/', redirect: '/home' },
    { path: '/login', component: Login },
    { path: '/dementia', component: Dementia },
    { path: '/home', component: Home },
    { path: '/logout', component: Logout },
    { path: '/videoL', component: videoL },
    { path: '/checkpoint', component: CheckPoint },
    { path: '/checkpoint/1', component: CheckPointClock },
    { path: '/checkpoint/2', component: CheckPointBathroom },
    { path: '/checkpoint/3', component: CheckPointTrash },
    { path: '/checkpoint/4', component: CheckPointScreen },
    { path: '/checkpoint/5', component: CheckPointCalculate },
    { path: '/checkpoint/6', component: CheckPointFlip },
]

const router = VueRouter.createRouter({    
    history: VueRouter.createWebHashHistory(),
    routes,
})

createApp(App).use(router).use(store).mount('#app');
// soundBackground();
